import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: "app-baja-fiesta",
  templateUrl: "./baja-fiesta.component.html",
  styleUrls: ["./baja-fiesta.component.scss"]
})
export class BajaFiestaComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/baja-fiesta/baja-fiesta.component.ts